import { type FactoryTypeImages } from '@common/types/factory';
import { type PlantTypeImages } from '@common/types/plant';
import {
  type ResourceTypeImages,
  type ResourceTypeText,
} from '@common/types/resource';

import {
  BACKGROUND_HOLIDAY_CONFIG,
  BACKGROUNDS_CONFIG,
  PICTURES_CONFIG,
} from '@/common/config/media-config';
import { type MarketBoxes } from '@/common/types/shop/marketBoxes';

//background
import backgroundPlantBrickJpg from '/img/bg/plant_Brick.jpg';
import backgroundPlantBrickWebp from '/img/bg/plant_Brick.webp';
import backgroundPlantGlassJpg from '/img/bg/plant_Glass.jpg';
import backgroundPlantGlassWebp from '/img/bg/plant_Glass.webp';
import backgroundPlantMicrochipJpg from '/img/bg/plant_Microchip.jpg';
import backgroundPlantMicrochipWebp from '/img/bg/plant_Microchip.webp';
import backgroundPlantOilRefineryJpg from '/img/bg/plant_Oil_refinery.jpg';
import backgroundPlantOilRefineryWebp from '/img/bg/plant_Oil_refinery.webp';
import backgroundPlantPaperJpg from '/img/bg/plant_Paper.jpg';
import backgroundPlantPaperWebp from '/img/bg/plant_Paper.webp';
import backgroundPlantPolymerJpg from '/img/bg/plant_Polymer.jpg';
import backgroundPlantPolymerWebp from '/img/bg/plant_Polymer.webp';
import backgroundPlantSawmillJpg from '/img/bg/plant_Sawmill.jpg';
import backgroundPlantSawmillWebp from '/img/bg/plant_Sawmill.webp';
import backgroundPlantSteelworksJpg from '/img/bg/plant_Steelworks.jpg';
import backgroundPlantSteelworksWebp from '/img/bg/plant_Steelworks.webp';
import backgroundPlantTextileJpg from '/img/bg/plant_Textile.jpg';
import backgroundPlantTextileWebp from '/img/bg/plant_Textile.webp';
//builds
import buildsChildrensGoodsPng from '/img/builds/building_factory/Childrens_Goods.png';
import buildsChildrensGoodsWebp from '/img/builds/building_factory/Childrens_Goods.webp';
import buildsElectronicsPng from '/img/builds/building_factory/Electronics.png';
import buildsElectronicsWebp from '/img/builds/building_factory/Electronics.webp';
import buildsFurnitureFactoryPng from '/img/builds/building_factory/Furniture_Factory.png';
import buildsFurnitureFactoryWebp from '/img/builds/building_factory/Furniture_Factory.webp';
import buildsGarmentFactoryPng from '/img/builds/building_factory/Garment_Factory.png';
import buildsGarmentFactoryWebp from '/img/builds/building_factory/Garment_Factory.webp';
import buildsHomewarePng from '/img/builds/building_factory/Homeware.png';
import buildsHomewareWebp from '/img/builds/building_factory/Homeware.webp';
import buildsMachineryPng from '/img/builds/building_factory/Machinery.png';
import buildsMachineryWebp from '/img/builds/building_factory/Machinery.webp';
import buildsMusicalInstrumentsPng from '/img/builds/building_factory/Musical_Instruments.png';
import buildsMusicalInstrumentsWebp from '/img/builds/building_factory/Musical_Instruments.webp';
import buildsPrintingFactoryPng from '/img/builds/building_factory/Printing_Factory.png';
import buildsPrintingFactoryWebp from '/img/builds/building_factory/Printing_Factory.webp';
import buildsToolmakingPng from '/img/builds/building_factory/Toolmaking.png';
import buildsToolmakingWebp from '/img/builds/building_factory/Toolmaking.webp';
import buildsBrickPlantPng from '/img/builds/building_plant/Brick_Plant.png';
import buildsBrickPlantWebp from '/img/builds/building_plant/Brick_Plant.webp';
import buildsGlassPlantPng from '/img/builds/building_plant/Glass_Plant.png';
import buildsGlassPlantWebp from '/img/builds/building_plant/Glass_Plant.webp';
import buildsMicrochipPlantPng from '/img/builds/building_plant/Microchip_Plant.png';
import buildsMicrochipPlantWebp from '/img/builds/building_plant/Microchip_Plant.webp';
import buildsOilRefineryPng from '/img/builds/building_plant/Oil_Refinery.png';
import buildsOilRefineryWebp from '/img/builds/building_plant/Oil_Refinery.webp';
import buildsPaperPlantPng from '/img/builds/building_plant/Paper_Plant.png';
import buildsPaperPlantWebp from '/img/builds/building_plant/Paper_Plant.webp';
import buildsPolymerPlantPng from '/img/builds/building_plant/Polymer_Plant.png';
import buildsPolymerPlantWebp from '/img/builds/building_plant/Polymer_Plant.webp';
import buildsSawmillPng from '/img/builds/building_plant/Sawmill.png';
import buildsSawmillWebp from '/img/builds/building_plant/Sawmill.webp';
import buildsSteelworksPng from '/img/builds/building_plant/Steelworks.png';
import buildsSteelworksWebp from '/img/builds/building_plant/Steelworks.webp';
import buildsTextilePlantPng from '/img/builds/building_plant/Textile_Plant.png';
import buildsTextilePlantWebp from '/img/builds/building_plant/Textile_Plant.webp';
import buildsCottonPng from '/img/builds/resources_cotton.png';
import buildsCottonWebp from '/img/builds/resources_cotton.webp';
import buildsPreciousPng from '/img/builds/resources_gold.png';
import buildsPreciousWebp from '/img/builds/resources_gold.webp';
import buildsIronPng from '/img/builds/resources_iron.png';
import buildsIronWebp from '/img/builds/resources_iron.webp';
import buildsOilPng from '/img/builds/resources_oil.png';
import buildsOilWebp from '/img/builds/resources_oil.webp';
import buildsBulkPng from '/img/builds/resources_quarry.png';
import buildsBulkWebp from '/img/builds/resources_quarry.webp';
import buildsWoodPng from '/img/builds/resources_sawmill.png';
import buildsWoodWebp from '/img/builds/resources_sawmill.webp';
//character
import characterFactoryChildrenPng from '/img/characters/factory_characters/factory_Children_Character.png';
import characterFactoryChildrenWebp from '/img/characters/factory_characters/factory_Children_Character.webp';
import characterFactoryElectronicsPng from '/img/characters/factory_characters/factory_Electronics_Character.png';
import characterFactoryElectronicsWebp from '/img/characters/factory_characters/factory_Electronics_Character.webp';
import characterFactoryFurniturePng from '/img/characters/factory_characters/factory_Furniture_Character.png';
import characterFactoryFurnitureWebp from '/img/characters/factory_characters/factory_Furniture_Character.webp';
import characterFactoryGarmentPng from '/img/characters/factory_characters/factory_Garment_Character.png';
import characterFactoryGarmentWebp from '/img/characters/factory_characters/factory_Garment_Character.webp';
import characterFactoryHomewarePng from '/img/characters/factory_characters/factory_Homeware_Character.png';
import characterFactoryHomewareWebp from '/img/characters/factory_characters/factory_Homeware_Character.webp';
import characterFactoryMachineryPng from '/img/characters/factory_characters/factory_Machinery_Character.png';
import characterFactoryMachineryWebp from '/img/characters/factory_characters/factory_Machinery_Character.webp';
import characterFactoryMusicalPng from '/img/characters/factory_characters/factory_Musical_Character.png';
import characterFactoryMusicalWebp from '/img/characters/factory_characters/factory_Musical_Character.webp';
import characterFactoryPrintingPng from '/img/characters/factory_characters/factory_Printing_Character.png';
import characterFactoryPrintingWebp from '/img/characters/factory_characters/factory_Printing_Character.webp';
import characterFactoryToolmakingPng from '/img/characters/factory_characters/factory_Toolmaking_Character.png';
import characterFactoryToolmakingWebp from '/img/characters/factory_characters/factory_Toolmaking_Character.webp';
import cashPng from '/img/icons/cash.png';
import cashWebp from '/img/icons/cash.webp';
import cashLargePng from '/img/icons/cash-large.png';
import cashLargeWebp from '/img/icons/cash-large.webp';
import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';
//goods
import goodsAccessories from '/img/icons/factory_icons/accessories.png';
import goodsAirplane from '/img/icons/factory_icons/airplane.png';
import goodsCar from '/img/icons/factory_icons/car.png';
import goodsConstructionToys from '/img/icons/factory_icons/construction_toys.png';
import goodsElectricFireplaces from '/img/icons/factory_icons/electric_fireplaces.png';
import goodsElectronicTools from '/img/icons/factory_icons/electronic_tools.png';
import goodsElectronicToys from '/img/icons/factory_icons/electronic_toys.png';
import goodsGardenFurniture from '/img/icons/factory_icons/garden_furniture.png';
import goodsLaptop from '/img/icons/factory_icons/laptop.png';
import goodsLightMusic from '/img/icons/factory_icons/light_music.png';
import goodsMachines from '/img/icons/factory_icons/machines.png';
import goodsOfficeFurniture from '/img/icons/factory_icons/office_furniture.png';
import goodsPhotoFrames from '/img/icons/factory_icons/photo_frames.png';
import goodsRobotics from '/img/icons/factory_icons/robotics.png';
import goodsShip from '/img/icons/factory_icons/ship.png';
import goodsSpeakers from '/img/icons/factory_icons/speakers.png';
import goodsSportsEquipment from '/img/icons/factory_icons/sports_equipment.png';
import goodsStationery from '/img/icons/factory_icons/stationery.png';
import goodsTableware from '/img/icons/factory_icons/tableware.png';
import goodsTrain from '/img/icons/factory_icons/train.png';
import goodsVrEquipment from '/img/icons/factory_icons/vr_equipment.png';
import leaguesPointPng from '/img/icons/leagues-point.png';
import leaguesPointWebp from '/img/icons/leagues-point.webp';
import usdPng from '/img/icons/usd.png';
import usdWebp from '/img/icons/usd.webp';
//mines
import minesBulkPng from '/img/mines/mine-bulk.png';
import minesBulkWebp from '/img/mines/mine-bulk.webp';
import minesCottonPng from '/img/mines/mine-cotton.png';
import minesCottonWebp from '/img/mines/mine-cotton.webp';
import minesIronPng from '/img/mines/mine-iron.png';
import minesIronWebp from '/img/mines/mine-iron.webp';
import minesOilPng from '/img/mines/mine-oil.png';
import minesOilWebp from '/img/mines/mine-oil.webp';
import minesPreciousPng from '/img/mines/mine-precious.png';
import minesPreciousWebp from '/img/mines/mine-precious.webp';
import minesWoodPng from '/img/mines/mine-wood.png';
import minesWoodWebp from '/img/mines/mine-wood.webp';
//resource
import resourceBoardsPng from '/img/resources/boards.png';
import resourceBoardsWebp from '/img/resources/boards.webp';
import resourceBricksPng from '/img/resources/brick-right.png';
import resourceBricksWebp from '/img/resources/brick-right.webp';
import resourceChipPng from '/img/resources/chip.png';
import resourceChipWebp from '/img/resources/chip.webp';
import resourceCottonLargePng from '/img/resources/cotton-large.png';
import resourceCottonLargeWebp from '/img/resources/cotton-large.webp';
import resourceFuelPng from '/img/resources/fuel.png';
import resourceFuelWebp from '/img/resources/fuel.webp';
import resourceGlassPng from '/img/resources/glass.png';
import resourceGlassWebp from '/img/resources/glass.webp';
import resourceGoldLargePng from '/img/resources/gold-large.png';
import resourceGoldLargeWebp from '/img/resources/gold-large.webp';
import resourceIronLargePng from '/img/resources/iron-large.png';
import resourceIronLargeWebp from '/img/resources/iron-large.webp';
import resourceOilLargePng from '/img/resources/oil-large.png';
import resourceOilLargeWebp from '/img/resources/oil-large.webp';
import resourcePaperPng from '/img/resources/paper.png';
import resourcePaperWebp from '/img/resources/paper.webp';
import resourcePlasticPng from '/img/resources/plastic.png';
import resourcePlasticWebp from '/img/resources/plastic.webp';
import resourceSandLargePng from '/img/resources/sand-large.png';
import resourceSandLargeWebp from '/img/resources/sand-large.webp';
import resourceSteelPng from '/img/resources/steel.png';
import resourceSteelWebp from '/img/resources/steel.webp';
import resourceCottonPng from '/img/resources/tab-cotton.png';
import resourceCottonWebp from '/img/resources/tab-cotton.webp';
import resourcePreciousPng from '/img/resources/tab-gold.png';
import resourcePreciousWebp from '/img/resources/tab-gold.webp';
import resourceIronPng from '/img/resources/tab-iron.png';
import resourceIronWebp from '/img/resources/tab-iron.webp';
import resourceOilPng from '/img/resources/tab-oil.png';
import resourceOilWebp from '/img/resources/tab-oil.webp';
import resourceBulkPng from '/img/resources/tab-sand.png';
import resourceBulkWebp from '/img/resources/tab-sand.webp';
import resourceWoodPng from '/img/resources/tab-wood.png';
import resourceWoodWebp from '/img/resources/tab-wood.webp';
import resourceTextilePng from '/img/resources/textile.png';
import resourceTextileWebp from '/img/resources/textile.webp';
import resourceWoodLargePng from '/img/resources/wood-large.png';
import resourceWoodLargeWebp from '/img/resources/wood-large.webp';
//shopBoxes
import adsPackPng from '/img/shop/boxes/ads_pack.png';
import adsPackWebp from '/img/shop/boxes/ads_pack.webp';
import elitePackPng from '/img/shop/boxes/elite_pack.png';
import elitePackWebp from '/img/shop/boxes/elite_pack.webp';
import freePackPng from '/img/shop/boxes/free_pack.png';
import freePackWebp from '/img/shop/boxes/free_pack.webp';
import goldPackPng from '/img/shop/boxes/gold_pack.png';
import goldPackWebp from '/img/shop/boxes/gold_pack.webp';
import proPackPng from '/img/shop/boxes/pro_pack.png';
import proPackWebp from '/img/shop/boxes/pro_pack.webp';
import starterPackPng from '/img/shop/boxes/starter_pack.png';
import starterPackWebp from '/img/shop/boxes/starter_pack.webp';
import tgemPng from '/img/tgem.png';
import tgemWebp from '/img/tgem.webp';
import tgemLargePng from '/img/tgem-big.png';
import tgemLargeWebp from '/img/tgem-big.webp';

export type ImageFormats = {
  png?: string;
  webp?: string;
  jpg?: string;
  pngRight?: string;
  webpRight?: string;
};
//Resource
export const resourceImages: ResourceTypeImages = {
  wood: {
    background: {
      png: BACKGROUNDS_CONFIG.BG_WOOD.png,
      webp: BACKGROUNDS_CONFIG.BG_WOOD.webp,
    },
    build: {
      png: buildsWoodPng,
      webp: buildsWoodWebp,
    },
    mine: {
      png: minesWoodPng,
      webp: minesWoodWebp,
    },
    icon: {
      png: resourceWoodPng,
      webp: resourceWoodWebp,
      pngRight: resourceWoodPng,
      webpRight: resourceWoodWebp,
    },
  },
  cotton: {
    background: {
      png: BACKGROUNDS_CONFIG.BG_COTTON.png,
      webp: BACKGROUNDS_CONFIG.BG_COTTON.webp,
    },
    build: {
      png: buildsCottonPng,
      webp: buildsCottonWebp,
    },
    mine: {
      png: minesCottonPng,
      webp: minesCottonWebp,
    },
    icon: {
      png: resourceCottonPng,
      webp: resourceCottonWebp,
    },
  },
  bulk: {
    background: {
      png: BACKGROUNDS_CONFIG.BG_SAND.png,
      webp: BACKGROUNDS_CONFIG.BG_SAND.webp,
    },
    build: {
      png: buildsBulkPng,
      webp: buildsBulkWebp,
    },
    mine: {
      png: minesBulkPng,
      webp: minesBulkWebp,
    },
    icon: {
      png: resourceBulkPng,
      webp: resourceBulkWebp,
    },
  },
  iron: {
    background: {
      png: BACKGROUNDS_CONFIG.BG_IRON.png,
      webp: BACKGROUNDS_CONFIG.BG_IRON.webp,
    },
    build: {
      png: buildsIronPng,
      webp: buildsIronWebp,
    },
    mine: {
      png: minesIronPng,
      webp: minesIronWebp,
    },
    icon: {
      png: resourceIronPng,
      webp: resourceIronWebp,
    },
  },
  oil: {
    background: {
      png: BACKGROUNDS_CONFIG.BG_OIL.png,
      webp: BACKGROUNDS_CONFIG.BG_OIL.webp,
    },
    build: {
      png: buildsOilPng,
      webp: buildsOilWebp,
    },
    mine: {
      png: minesOilPng,
      webp: minesOilWebp,
    },
    icon: {
      png: resourceOilPng,
      webp: resourceOilWebp,
    },
  },
  precious: {
    background: {
      png: BACKGROUNDS_CONFIG.BG_GOLD.png,
      webp: BACKGROUNDS_CONFIG.BG_GOLD.webp,
    },
    build: {
      png: buildsPreciousPng,
      webp: buildsPreciousWebp,
    },
    mine: {
      png: minesPreciousPng,
      webp: minesPreciousWebp,
    },
    icon: {
      png: resourcePreciousPng,
      webp: resourcePreciousWebp,
    },
  },
};
//Plant
export const plantImages: PlantTypeImages = {
  lumber: {
    background: {
      jpg: backgroundPlantSawmillJpg,
      webp: backgroundPlantSawmillWebp,
    },
    build: {
      png: buildsSawmillPng,
      webp: buildsSawmillWebp,
    },
    icon: {
      png: resourceBoardsPng,
      webp: resourceBoardsWebp,
      pngRight: resourceBoardsPng,
      webpRight: resourceBoardsWebp,
    },
  },
  textiles: {
    background: {
      jpg: backgroundPlantTextileJpg,
      webp: backgroundPlantTextileWebp,
    },
    build: {
      png: buildsTextilePlantPng,
      webp: buildsTextilePlantWebp,
    },
    icon: {
      png: resourceTextilePng,
      webp: resourceTextileWebp,
    },
  },
  bricks: {
    background: {
      jpg: backgroundPlantBrickJpg,
      webp: backgroundPlantBrickWebp,
    },
    build: {
      png: buildsBrickPlantPng,
      webp: buildsBrickPlantWebp,
    },
    icon: {
      png: resourceBricksPng,
      webp: resourceBricksWebp,
    },
  },
  paper: {
    background: {
      jpg: backgroundPlantPaperJpg,
      webp: backgroundPlantPaperWebp,
    },
    build: {
      png: buildsPaperPlantPng,
      webp: buildsPaperPlantWebp,
    },
    icon: {
      png: resourcePaperPng,
      webp: resourcePaperWebp,
    },
  },
  steel: {
    background: {
      jpg: backgroundPlantSteelworksJpg,
      webp: backgroundPlantSteelworksWebp,
    },
    build: {
      png: buildsSteelworksPng,
      webp: buildsSteelworksWebp,
    },
    icon: {
      png: resourceSteelPng,
      webp: resourceSteelWebp,
      pngRight: resourceSteelPng,
      webpRight: resourceSteelWebp,
    },
  },
  plastic: {
    background: {
      jpg: backgroundPlantPolymerJpg,
      webp: backgroundPlantPolymerWebp,
    },
    build: {
      png: buildsPolymerPlantPng,
      webp: buildsPolymerPlantWebp,
    },
    icon: {
      png: resourcePlasticPng,
      webp: resourcePlasticWebp,
    },
  },
  glass: {
    background: {
      jpg: backgroundPlantGlassJpg,
      webp: backgroundPlantGlassWebp,
    },
    build: {
      png: buildsGlassPlantPng,
      webp: buildsGlassPlantWebp,
    },
    icon: {
      png: resourceGlassPng,
      webp: resourceGlassWebp,
    },
  },
  fuels_and_oils: {
    background: {
      jpg: backgroundPlantOilRefineryJpg,
      webp: backgroundPlantOilRefineryWebp,
    },
    build: {
      png: buildsOilRefineryPng,
      webp: buildsOilRefineryWebp,
    },
    icon: {
      png: resourceFuelPng,
      webp: resourceFuelWebp,
    },
  },
  microchips: {
    background: {
      jpg: backgroundPlantMicrochipJpg,
      webp: backgroundPlantMicrochipWebp,
    },
    build: {
      png: buildsMicrochipPlantPng,
      webp: buildsMicrochipPlantWebp,
    },
    icon: {
      png: resourceChipPng,
      webp: resourceChipWebp,
    },
  },
};
//Factory
export const factoryImages: FactoryTypeImages = {
  furniture_factory: {
    character: {
      png: characterFactoryFurniturePng,
      webp: characterFactoryFurnitureWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_FURNITURE ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_FURNITURE
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_FURNITURE ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_FURNITURE
      )?.webp,
    },
    build: {
      png: buildsFurnitureFactoryPng,
      webp: buildsFurnitureFactoryWebp,
    },
    icons: {
      furniture: PICTURES_CONFIG.FURNITURE_ICON.png,
      upholstered_furniture: PICTURES_CONFIG.UPHOLSTERED_FURNITURE_ICON.png,
      garden_furniture: goodsGardenFurniture,
      office_furniture: goodsOfficeFurniture,
    },
  },
  garment_factory: {
    character: {
      png: characterFactoryGarmentPng,
      webp: characterFactoryGarmentWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_GARMENT ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_GARMENT
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_GARMENT ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_GARMENT
      )?.webp,
    },
    build: {
      png: buildsGarmentFactoryPng,
      webp: buildsGarmentFactoryWebp,
    },
    icons: {
      clothing: PICTURES_CONFIG.CLOTHING_ICON.png,
      footwear: PICTURES_CONFIG.FOOTWEAR_ICON.png,
      accessories: goodsAccessories,
      sports_equipment: goodsSportsEquipment,
    },
  },
  printing_factory: {
    character: {
      png: characterFactoryPrintingPng,
      webp: characterFactoryPrintingWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_PRINTED ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_PRINTED
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_PRINTED ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_PRINTED
      )?.webp,
    },
    build: {
      png: buildsPrintingFactoryPng,
      webp: buildsPrintingFactoryWebp,
    },
    icons: {
      books: PICTURES_CONFIG.BOOKS_ICON.png,
      packaging: PICTURES_CONFIG.PACKAGING_ICON.png,
      photo_frames: goodsPhotoFrames,
      stationery: goodsStationery,
    },
  },
  homeware: {
    character: {
      png: characterFactoryHomewarePng,
      webp: characterFactoryHomewareWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_HOMEWARE ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_HOMEWARE
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_HOMEWARE ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_HOMEWARE
      )?.webp,
    },
    build: {
      png: buildsHomewarePng,
      webp: buildsHomewareWebp,
    },
    icons: {
      home_textiles: PICTURES_CONFIG.HOME_TEXTILES_ICON.png,
      lamps: PICTURES_CONFIG.LAMPS_ICON.png,
      tableware: goodsTableware,
      electric_fireplaces: goodsElectricFireplaces,
    },
  },
  toolmaking: {
    character: {
      png: characterFactoryToolmakingPng,
      webp: characterFactoryToolmakingWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_TOOLMAKING ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_TOOLMAKING
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_TOOLMAKING ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_TOOLMAKING
      )?.webp,
    },
    build: {
      png: buildsToolmakingPng,
      webp: buildsToolmakingWebp,
    },
    icons: {
      hand_tools: PICTURES_CONFIG.HAND_TOOLS_ICON.png,
      garden_tools: PICTURES_CONFIG.GARDEN_TOOLS_ICON.png,
      electronic_tools: goodsElectronicTools,
      machines: goodsMachines,
    },
  },
  childrens_goods: {
    character: {
      png: characterFactoryChildrenPng,
      webp: characterFactoryChildrenWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_CHILDRENS ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_CHILDRENS
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_CHILDRENS ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_CHILDRENS
      )?.webp,
    },
    build: {
      png: buildsChildrensGoodsPng,
      webp: buildsChildrensGoodsWebp,
    },
    icons: {
      soft_toys: PICTURES_CONFIG.SOFT_TOYS_ICON.png,
      board_games: PICTURES_CONFIG.BOARD_GAMES_ICON.png,
      construction_toys: goodsConstructionToys,
      electronic_toys: goodsElectronicToys,
    },
  },
  musical_equipment: {
    character: {
      png: characterFactoryMusicalPng,
      webp: characterFactoryMusicalWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_MUSIC ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_MUSIC
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_MUSIC ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_MUSIC
      )?.webp,
    },
    build: {
      png: buildsMusicalInstrumentsPng,
      webp: buildsMusicalInstrumentsWebp,
    },
    icons: {
      guitar: PICTURES_CONFIG.GUITAR_ICON.png,
      electric_guitar: PICTURES_CONFIG.ELECTRIC_GUITAR_ICON.png,
      light_music: goodsLightMusic,
      speakers: goodsSpeakers,
    },
  },
  electronics: {
    character: {
      png: characterFactoryElectronicsPng,
      webp: characterFactoryElectronicsWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_ELECTRONICS ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_ELECTRONICS
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_ELECTRONICS ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_ELECTRONICS
      )?.webp,
    },
    build: {
      png: buildsElectronicsPng,
      webp: buildsElectronicsWebp,
    },
    icons: {
      washing_machine: PICTURES_CONFIG.WASHING_MACHINE_ICON.png,
      laptop: goodsLaptop,
      vr_equipment: goodsVrEquipment,
      robotics: goodsRobotics,
    },
  },
  machinery: {
    character: {
      png: characterFactoryMachineryPng,
      webp: characterFactoryMachineryWebp,
    },
    background: {
      jpg: (
        BACKGROUNDS_CONFIG.BG_FACTORY_MECHANIC ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_MECHANIC
      )?.png,
      webp: (
        BACKGROUNDS_CONFIG.BG_FACTORY_MECHANIC ??
        BACKGROUND_HOLIDAY_CONFIG.default.BG_FACTORY_MECHANIC
      )?.webp,
    },
    build: {
      png: buildsMachineryPng,
      webp: buildsMachineryWebp,
    },
    icons: {
      car: goodsCar,
      train: goodsTrain,
      airplane: goodsAirplane,
      ship: goodsShip,
    },
  },
};
export const currencyImages: Record<
  'cash' | 'tgem',
  {
    default: { png: string; webp: string };
    large: { png: string; webp: string };
  }
> = {
  cash: {
    default: {
      png: cashPng,
      webp: cashWebp,
    },
    large: {
      png: cashLargePng,
      webp: cashLargeWebp,
    },
  },
  tgem: {
    default: {
      png: tgemPng,
      webp: tgemWebp,
    },
    large: {
      png: tgemLargePng,
      webp: tgemLargeWebp,
    },
  },
};
export const walletImages = {
  cash: {
    png: cashPng,
    webp: cashWebp,
  },
  tgem: {
    png: tgemPng,
    webp: tgemWebp,
  },
  leaguePoints: {
    png: leaguesPointPng,
    webp: leaguesPointWebp,
  },
  dice: {
    png: dicePng,
    webp: diceWebp,
  },
  ton: {
    png: usdPng,
    webp: usdWebp,
  },
  usdt: {
    png: usdPng,
    webp: usdWebp,
  },
};
export const largeResourceIcons: Record<
  ResourceTypeText,
  { png: string; webp: string }
> = {
  wood: {
    png: resourceWoodLargePng,
    webp: resourceWoodLargeWebp,
  },
  cotton: {
    png: resourceCottonLargePng,
    webp: resourceCottonLargeWebp,
  },
  bulk: {
    png: resourceSandLargePng,
    webp: resourceSandLargeWebp,
  },
  oil: {
    png: resourceOilLargePng,
    webp: resourceOilLargeWebp,
  },
  iron: {
    png: resourceIronLargePng,
    webp: resourceIronLargeWebp,
  },
  precious: {
    png: resourceGoldLargePng,
    webp: resourceGoldLargeWebp,
  },
};
export const shopBoxesImages: Record<
  MarketBoxes,
  { png: string; webp: string }
> = {
  free: {
    png: freePackPng,
    webp: freePackWebp,
  },
  ads: {
    png: adsPackPng,
    webp: adsPackWebp,
  },
  starter: {
    png: starterPackPng,
    webp: starterPackWebp,
  },
  pro: {
    png: proPackPng,
    webp: proPackWebp,
  },
  gold: {
    png: goldPackPng,
    webp: goldPackWebp,
  },
  elit: {
    png: elitePackPng,
    webp: elitePackWebp,
  },
};
export const images = {
  resource: resourceImages,
  material: plantImages,
  goods: factoryImages,
};
